import { LicenseModelApi, LicenseModel } from '../../../../domainModels/licences/LicenseModel';
import { LicenseStatus, LicenseStatusEnum } from '../../../../domainModels/licences/LicenseStatus';
import { LicenseVersion, LicenseVersionApi } from '../../../../domainModels/licences/LicenseVersion';
import { generateGuid } from '../../../../helpers/guid';
import { createDateFromTimeZone } from '../../../../helpers/moment';

export const mapApiLicenseVersionToModel = (model: LicenseVersionApi): LicenseVersion => ({
    ...model,
    paymentDeadline: createDateFromTimeZone(model.paymentDeadline, undefined, 'utc'),
    validFrom: createDateFromTimeZone(model.validFrom, undefined, 'utc'),
    validTo: createDateFromTimeZone(model.validTo, undefined, 'utc'),
    paymentStatus: model.paymentStatus,
    type: model.type,
    distributorId: model.distributorId,
});

export const mapApiLicenseModel = (model: LicenseModelApi): LicenseModel => ({
    ...model,
    licenseVersions: model.licenseVersions.map(item => mapApiLicenseVersionToModel(item)),
    status: model.status.toString() === LicenseStatus.Active.toString() ? LicenseStatusEnum.Active : model.status,
    id: generateGuid(),
    tokenValidFrom: model.tokenValidFrom ? createDateFromTimeZone(model.tokenValidFrom, undefined, 'utc') : undefined,
    tokenValidTo: model.tokenValidTo ? createDateFromTimeZone(model.tokenValidTo, undefined, 'utc') : undefined,
});
